// extracted by mini-css-extract-plugin
module.exports = {"root":"LoginPage_root__3G0y1"};